import { fetchQueryData } from 'hooks/use-gremlin-query'
import { kubernetesQueryKeys } from 'queries/kubernetes/query-keys'
import { getEndpointWithParams } from 'queries/queries-utils'

import type { QueryFunctionContext } from 'react-query'

export function getKubernetesTargetsKinds({
  queryKey: [endpoint, params]
}: QueryFunctionContext<
  ReturnType<typeof kubernetesQueryKeys.getKubernetesTargetsKinds>
>) {
  const endpointWithParams = getEndpointWithParams(endpoint, params)

  return fetchQueryData<string[]>(endpointWithParams, {})
}
